/**
 * Wordmark Wérko — signature de marque.
 *
 * Rendu deux-tons par défaut : lettres 'w', 'r', 'k', 'o' en sable (#E8DCC8),
 * accent 'é' en terracotta (#C4553B). Sora Bold, tout en minuscules.
 *
 * Usage :
 *   <WerkoWordmark size="lg" />   → hero
 *   <WerkoWordmark size="md" />   → header page publique
 *   <WerkoWordmark size="sm" />   → sidebar backoffice
 *   <WerkoWordmark fallback />    → mono-couleur terracotta (fallback contraste)
 *
 * ⚠️ Le wordmark 'wérko' minuscule est réservé aux logos.
 *    Dans les corps de texte, utiliser 'Wérko' avec majuscule initiale.
 */

const SIZE_CLASSES = {
  sm: "text-lg",
  md: "text-3xl",
  lg: "text-5xl sm:text-6xl",
};

export function WerkoWordmark({ size = "md", fallback = false, className = "" }) {
  const sizeCls = SIZE_CLASSES[size] || SIZE_CLASSES.md;
  const base = `font-heading font-bold tracking-tight leading-none ${sizeCls} ${className}`;

  if (fallback) {
    return (
      <span
        className={`${base} text-[#C4553B]`}
        aria-label="wérko"
        data-testid="werko-wordmark"
      >
        wérko
      </span>
    );
  }

  return (
    <span
      className={base}
      aria-label="wérko"
      data-testid="werko-wordmark"
    >
      <span className="text-platform-heading">w</span>
      <span className="text-[#C4553B]">é</span>
      <span className="text-platform-heading">rko</span>
    </span>
  );
}

export default WerkoWordmark;
